import React from 'react'

import {
  array, number,
} from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import avatarUrl from 'images/avatar/job_assistant.jpg'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import InboxItem from './Components/InboxItem/InboxItem'

function Inbox({ messages, included = EMPTY_ARRAY, unreadCount = 0 }) {
  const userIncluded = included.filter(data => data.type === 'conversationUsers')
  const conversationIncluded = included.filter(data => data.type === 'conversations')

  function getUserInfo(id) {
    return userIncluded.filter(user => user.id === id)[0].attributes
  }

  function getConversationInfo(id) {
    return conversationIncluded.filter(conversation => conversation.id === id)[0]
  }

  function messageComponentProps(message, index) {
    const conversation = getConversationInfo(message.relationships.conversation.data.id)

    return {
      key: `${message.id}-${index}`,
      isRead: message.attributes.isRead,
      date: message.attributes.date,
      body: message.attributes.message,
      conversation: {
        id: conversation.id,
        subject: conversation.attributes.subject,
        /* eslint-disable-next-line no-undef */
        type: I18n.t(conversation.attributes.conversationType, { scope: 'navigation.conversations_widget.types' }),
      },
    }
  }

  function messageComponents() {
    return messages.map((message, index) => {
      const messageProps = messageComponentProps(message, index)

      if (message.attributes.systemMessage) {
        const user = {
          username: 'Projects Assistant',
          profileUrl: '',
          avatar: {
            url: avatarUrl,
          },
        }

        return <InboxItem {...messageProps} user={user} isReceived />
      }
      const user = getUserInfo(message.relationships.user.data.id)

      return <InboxItem {...messageProps} user={user} isReceived={message.attributes.isReceived} />
    })
  }

  return (
    <div className="popover-content no-pad-left-right feed-container--inbox">
      {unreadCount > 0 && (
        <div className="feed-list__separator"><span>{unreadCount} new</span></div>
      )}
      {messageComponents(messages)}
      <div className="popover-content__actions">
        <a href="/profile/inbox" className="btn btn-transparent btn-block btn-learn-more">
          Show all
        </a>
      </div>
    </div>
  )
}

Inbox.propTypes = {
  messages: array.isRequired,
  included: array,
  unreadCount: number,
}

export default Inbox
